import _ from 'lodash';
import roles from 'app/validators/roles';

function canLoginAs(model) {
  const role = _.get(model, 'session.role');
  return model.user.editAccount.isAccountActive && roles.ADMIN_ROLES.indexOf(role) >= 0;
}

const validators = {
  'auth.loginAs': [canLoginAs],
};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/auth/validators/action-validators.js